import { IconProps } from './IconProps';

const ChevronLeftIcon = ({ className }: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M15 6l-6 6 6 6" />
  </svg>
);

export default ChevronLeftIcon;
